module.exports = __webpack_public_path__ + "static/media/loading.95d2939f.svg";